'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _DragAndDrop = require('./DragAndDrop');

var _FileUploadInput = require('./FileUploadInput');

var _FileUploadInput2 = _interopRequireDefault(_FileUploadInput);

var _WithError = require('./WithError');

var _WithError2 = _interopRequireDefault(_WithError);

var _dom = require('./utility/dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react2.default.PureComponent || _react2.default.Component;

var FileUpload = (_temp2 = _class = function (_PureComponent) {
	_inherits(FileUpload, _PureComponent);

	function FileUpload() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, FileUpload);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			draggedOver: false
		}, _this.onClick = function (event) {
			var _this$props = _this.props,
			    disabled = _this$props.disabled,
			    onClick = _this$props.onClick;

			if (disabled) {
				if (event) {
					event.preventDefault();
				}
				return;
			}
			if (onClick) {
				onClick();
			}
			_this.fileInput.click();
		}, _this.onKeyDown = function (event) {
			if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
				return;
			}
			switch (event.keyCode) {
				// "Enter".
				case 13:
				// Spacebar.
				case 32:
					event.preventDefault();
					// Emulate `:active` on key press.
					// setTimeout(() => {
					// 	if (this._isMounted) {
					// 		this.setState({
					// 			isActive: true
					// 		})
					// 	}
					// })
					return _this.onClick();
			}
		}, _this.setDraggedOver = function (draggedOver) {
			return _this.setState({ draggedOver: draggedOver });
		}, _this.storeFileInputRef = function (ref) {
			return _this.fileInput = ref;
		}, _this.onFileInputChange = function (value) {
			var _this$props2 = _this.props,
			    multiple = _this$props2.multiple,
			    onChange = _this$props2.onChange;

			if (multiple) {
				onChange(value, {
					acceptedFiles: value,
					rejectedFiles: []
				});
			} else {
				onChange(value, {
					isAccepted: true
				});
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(FileUpload, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    ref_ = _props.ref_,
			    required = _props.required,
			    error = _props.error,
			    disabled = _props.disabled,
			    tabIndex = _props.tabIndex,
			    onChange = _props.onChange,
			    multiple = _props.multiple,
			    accept = _props.accept,
			    ext = _props.ext,
			    style = _props.style,
			    className = _props.className,
			    children = _props.children;
			var draggedOver = this.state.draggedOver;


			var _accept = accept || ext && (0, _FileUploadInput.getAcceptFromExt)(ext);

			return _react2.default.createElement(
				_WithError2.default,
				{
					error: error,
					style: style,
					className: (0, _classnames2.default)('rrui__file-upload', className) },
				_react2.default.createElement(_FileUploadInput2.default, {
					ref: this.storeFileInputRef,
					multiple: multiple,
					onChange: this.onFileInputChange,
					error: error,
					required: required,
					disabled: disabled,
					accept: _accept,
					'aria-label': this.props['aria-label'] }),
				_react2.default.createElement(
					_DragAndDrop.DropFiles,
					{
						ref: ref_,
						role: 'button',
						tabIndex: tabIndex,
						'aria-label': this.props['aria-label'],
						accept: _accept,
						multiple: multiple,
						onDrop: onChange,
						onClick: this.onClick,
						onKeyDown: this.onKeyDown,
						setDraggedOver: this.setDraggedOver,
						className: (0, _classnames2.default)(
						/* Developers should define `:focus` styles for `<FileUpload/>`s. */
						'rrui__outline', 'rrui__file-upload__area', {
							'rrui__file-upload__area--disabled': disabled,
							'rrui__file-upload__area--invalid': error,
							'rrui__file-upload__area--dragged-over': draggedOver
						}) },
					children
				)
			);
		}
	}]);

	return FileUpload;
}(PureComponent), _class.propTypes = {
	// On file(s) chosen.
	onChange: _propTypes2.default.func,

	// Allows choosing multiple files if `true`.
	multiple: _propTypes2.default.bool,

	// Can be used to restrict the file MIME-types or extensions available for selection.
	// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#attr-accept
	accept: _propTypes2.default.string,

	// Will be transformed to `accept`.
	ext: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),

	// Disables the file input.
	disabled: _propTypes2.default.bool,

	// `onClick` handler.
	onClick: _propTypes2.default.func,

	// Whether choosing a file (or files) is required.
	required: _propTypes2.default.bool,

	// Indicates that the input is invalid.
	error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),

	tabIndex: _propTypes2.default.number.isRequired,

	// The clickable area, like "Click here to choose a file".
	children: _propTypes2.default.node,

	// CSS class
	className: _propTypes2.default.string,

	// CSS style object
	style: _propTypes2.default.object,

	// Deprecated.
	// Rewrite this component in hooks instead.
	// A hack for `React.forwardRef()`.
	// Could be rewritten in "hooks" instead.
	// A hack for providing `.focus()` method on `<DropFileUpload/>`.
	ref_: _propTypes2.default.object
}, _class.defaultProps = {
	tabIndex: 0
}, _temp2);

// A hack for providing `.focus()` method on `<DropFileUpload/>`.

exports.default = _react2.default.forwardRef(function (props, ref) {
	return _react2.default.createElement(FileUpload, _extends({ ref_: ref }, props));
});
//# sourceMappingURL=FileUpload.js.map